import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import AgreementsPost from './AgreementsPost';
import AgreementsPatch from './AgreementsPatch';
import AgreementsTable from './AgreementsTable';

export default function Agreements({
  agreementcategories,
  agreements,
  agreementstatuses,
  cities,
  city,
  district,
  districts,
  onSetAgreements,
}) {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route
        path="post"
        element={(
          <AgreementsPost
            agreementcategories={agreementcategories}
            agreements={agreements}
            agreementstatuses={agreementstatuses}
            cities={cities}
            city={city}
            district={district}
            districts={districts}
            onBack={() => navigate(`/${district ? district.id : '-'}/${city ? city.id : '-'}/agreements`)}
            onSetAgreements={onSetAgreements}
          />
        )}
      />
      <Route
        path=":agreementid"
        element={(
          <AgreementsPatch
            agreementcategories={agreementcategories}
            agreements={agreements}
            agreementstatuses={agreementstatuses}
            cities={cities}
            city={city}
            district={district}
            districts={districts}
            onBack={() => navigate(`/${district ? district.id : '-'}/${city ? city.id : '-'}/agreements`)}
            onSetAgreements={onSetAgreements}
          />
        )}
      />
      <Route
        path="/"
        element={(
          <AgreementsTable
            agreementcategories={agreementcategories}
            agreements={agreements}
            agreementstatuses={agreementstatuses}
            cities={cities}
            city={city}
            district={district}
            districts={districts}
            onRowClick={(id) => navigate(`/${district ? district.id : '-'}/${city ? city.id : '-'}/agreements/${id}`)}
            onAddClick={() => navigate(`/${district ? district.id : '-'}/${city ? city.id : '-'}/agreements/post`)}
          />
        )}
      />
    </Routes>
  );
}

Agreements.propTypes = {
  agreementcategories: PropTypes.arrayOf(PropTypes.shape({})),
  agreements: PropTypes.arrayOf(PropTypes.shape({})),
  agreementstatuses: PropTypes.arrayOf(PropTypes.shape({})),
  cities: PropTypes.arrayOf(PropTypes.shape({})),
  city: PropTypes.shape({
    id: PropTypes.number,
  }),
  district: PropTypes.shape({
    id: PropTypes.number,
  }),
  districts: PropTypes.arrayOf(PropTypes.shape({})),
  onSetAgreements: PropTypes.func.isRequired,
};

Agreements.defaultProps = {
  agreementcategories: undefined,
  agreements: undefined,
  agreementstatuses: undefined,
  cities: undefined,
  city: undefined,
  district: undefined,
  districts: undefined,
};
